export const RIGHT_TO_LEFT_MARK = "\u200F";
export const SPACE_CHAR = String.fromCharCode(32);
export const NOBREAK_SPACE_CHAR = String.fromCharCode(160);
// const PLACEHOLDER = "{0}";
// export const LEFT_TO_RIGHT_MARK = "\u200E";
// export const NB_SPACE_UNICODE = "\u00A0";

/**
 * this is equivalent to   const regex =   /( | )\{0}$/        which is harder to read and understand that one is the space and the other is no-break space
 * @type {RegExp}
 */
const regex = new RegExp(`(${SPACE_CHAR}|${NOBREAK_SPACE_CHAR})\\{0}$`);
/**
 * see HTML-4947 HTML-4953
 * so far the bug occurred only in Translations for Arabic where the placeholder is meant to be at the end of the sentence  ( that means on the LEFT side ) therefore the hack is very specific to  placeholder numbered 0
 * (named placeholder afaik are not used, multiple placeholders work fine and when a single placeholder is placed in the middle of a sentence it is also displayed correctly)
 */

const indexOfPlaceholder = (text) => {
    const match = text.match(regex);
    return match ? match.index : -1;
};



/**
 * THIS IS SUPPOSED TO BE CALLED ONLY FOR ARABIC TEXTS!
 * if text contains a placeholder in the position that causes the bug reverse order of text
 *
 * bug HTML-4947 HTML-4953
 * for some reason when placehoder is at the end of the sentence in english, (and therefore is flipped to the right in arabic)
 * regex works fine but only numbers are correctly displayed while strings stay on the left
 * Castle Davide --->  should become Davide Castle (with castle written in arab letters - reading from right)    BUT it is still displayed as Castle Davide
 * !!  when looking at the Text string before the replacement the placeholder looks completely broken but is just a display thing.   placeholder replacment works fine. ( beside this specific behaviour for strings)
 * Level 100 -->  100 Level (with level and digits written in arab letters - reading from right)

 * @param text
 * @returns {string}
 */
export const reverseSinglePlaceholder = (text: string) => {
    const i = indexOfPlaceholder(text);
    if (i != -1) {
        const rest = text.slice(0, i);
        const placeholder = text.slice(i).split("");
        placeholder.push(placeholder.shift());
        const reversed = placeholder.join("") + rest;
        return reversed;
    }
    else {
        return text;
    }
}




/**
 * * THIS IS SUPPOSED TO BE CALLED ONLY FOR ARABIC TEXTS!
 * Move dot and exclamation mark to end of sentence (LEFT)
 * see bug ticket HTML-4946
 * @param text
 * @returns {any}
 */
export const reversePunctuation = (text) => {
    const movePunctuationToLeft = (char) => {
        const regex = new RegExp('\\' + char, "g");
        const replacement = " " + char + RIGHT_TO_LEFT_MARK; //we need a space because is more proper for arabic and otherwise RTL mark does not work
        text = text.replace(regex, replacement)
    }
    movePunctuationToLeft("!");
    //  movePunctuationToLeft("?");  it seems there are no questionmarks in the arabic translations.  there are some in the ar.json file but all questions are in english
    movePunctuationToLeft(".");
    return text;
}
